<style>
.task-container {
  transition: all .5s;
  text-align: center;
  border: 1px solid rgba(0, 0, 0, 0.125);
  display: flex;
  padding-left: 0;
  height: 100%;
  max-height: inherit;
  box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.15);
  border-radius: 1rem;
  position: relative;
  padding-left: 0 !important;
  min-height: 700px;
  max-height: 700px;
  z-index: 90;
  background-color: transparent;
}

.task-container.highlight {
  background-color: rgba(0, 128, 0, 0.1); /* Colore di evidenziazione */
  z-index: 99;
}

.task-count {
  position: absolute;
  top: -15px;
  right: 0;
  z-index: 10;
  font-weight: bold;
  background-color: var(--bs-primary);
  width: 35px;
  height: 35px;
  border-radius: 100%;
  color: white;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}





.task-container.collapsed:after {
  content: "";
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  z-index: 99;
}

.task-container .status {
  writing-mode: vertical-rl;
  text-orientation: upright;
  font-weight: bold;
  border-right: 1px solid rgba(0, 0, 0, 0.125);
  margin: 0;
  padding-right: 10px;
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  border-top-left-radius: 1rem;
  border-bottom-left-radius: 1rem;
  //position: relative;
  z-index: -1;
  position: relative;
}

.task-container .lista-tasks {
  width: 100%;
  text-align: center;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  padding-top: calc(var(--bs-gutter-x) * 0.5);
  padding-bottom: calc(var(--bs-gutter-x) * 0.5);
  position: relative;
  //min-height: inherit;
  display: grid;
  grid-gap: 20px;
  /* flex-direction: row; */
  /* flex-wrap: wrap; */
  grid-template-columns: repeat(auto-fill, minmax(400px, 400px));
  grid-auto-rows: min-content;
  max-height: inherit;
  min-height: inherit;
}

.vue-simple-context-menu {
  position: fixed !important;
}

.vue-simple-context-menu__item {
  font-family: var(--bs-font-sans-serif);
}


.task-container .status-BACKLOG {
  background: #6c757d;
  color: white;
}

.task-container .status-TODO {
  background: #007bff;
  color: white;
}

.task-container .status-REVIEW {
  background: #ffc107;
  color: white;
}

.task-container .status-DONE {
  background: #28a745;
  color: white;
}

.refresher{
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
}

.hide {
  display: none !important;
}

</style>

<template>
  <div class="task-container" :class="{ 'expanded': expanded, 'collapsed': !expanded }" @click="expand()"
    @drop="taskDrop($event)" @dragover="allowDrop($event)">
    <div class="task-count">
      <span>{{ tasks.length }}</span>
    </div>
    <div class="status" :class="'status-' + taskStatus">
      <div @click="reloadData" class="refresher" v-show="!isPM">
        <i  class="pi pi-refresh" ></i>
      </div>
      <p >
        {{ taskStatus }}
      </p>
    </div>

    <div class="lista-tasks" :class="'lista-tasks-' + taskStatus" :id="'task-container-' + taskStatus"
      @contextmenu="onRightClickCreaTask($event)">
      <k-task v-for="(item) in tasks" :key="item.id" :task-entity="item" :is-p-m="isPM" :allow-feedback-ts="allowFeedbackTs"
        :permetti-hover="permettiHoverTask" @contextmenu="onRightClick($event, item)"></k-task>
      <ContextMenu ref="menu" :model="contextMenuActions" @hide="contextClosed" />
    </div>
    <ContextMenu ref="menuCreaTask" :model="contextMenuCreaTask" @hide="creatingTask = false" />
  </div>



</template>

<script>
import KTask from "@/views/taskSprint/components/task.vue";
import ContextMenu from 'primevue/contextmenu';
import CustomButton from 'primevue/button';
import CustomDialog from "primevue/dialog";
import * as $ from 'jquery'
export default {
  name: "KTaskContainer",
  components: { KTask, ContextMenu },

  props: {
    expandedOnStart: {
      type: Boolean,
      default: false,
    },
    allowFeedbackTs: {
      type: Boolean,
      default: true,
    },
    taskStatus: {
      type: String,
      default: 'TODO',
    },
    userId: {
      type: String,
      default: undefined
    },
    isPM: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      expanded: this.expandedOnStart,
      creatingTask: false,
      selectedTask: {},
      tasks: [],
      occupied: [],
      permettiHoverTask: true,
      contextMenuSelected: null,
      showProgrammaTask:false,
      contextMenuActions: [
        {
          label: 'Modifica TS',
          command: () => {
            this.$store.dispatch('creaTaskSprint', { userId: this.userId, status: this.taskStatus, modifica: true, task: { ...this.selectedTask } });
          },
          slug: 'modificaTS',
        },
        {
          label: 'Timbratura',
          command: () => {
            window.parent.postMessage({
              operation:'timbraturaTaskSprint',
              task:JSON.stringify(this.selectedTask)
            }, process.env.VUE_APP_QUIK_URL);
          },
          slug: 'startTimbratura',
        },

        {
          label: 'Cambia esecutore',
          command: () => {
            this.$store.dispatch('cambiaEsecutore', {
              idTask: this.selectedTask.id,
              status: this.selectedTask.status,
              idOwner: this.selectedTask.idOwner,
              dodAttuale:this.selectedTask.descrizione,
              idTicket:this.selectedTask.idTicket,
              orePreviste:this.selectedTask.orePreviste,
              forcePM:this.selectedTask.forcePM,
              idPmForzato:this.selectedTask.idPmForzato
            });
          },
          slug: 'cambiaEsecutore',
        },
        {
          label: 'Duplica',
          command: () => {
            this.$store.dispatch('creaTaskSprint', { userId: this.userId, status: this.taskStatus, duplica: true, task: { ...this.selectedTask } });
          },
          slug: 'duplica',
        },
        {
          label: 'Riprogramma TS',
          command: () => {
            this.$store.dispatch('startRiprogrammaTs', {  ...this.selectedTask  });
          },
          slug: 'riprogramma',
        },
        {
          separator: true
        },
        {
          label: 'Dettaglio ticket',
          command: () => {
            window.parent.postMessage({
              operation:'visualizzaDettaglioTicket',
              task:JSON.stringify(this.selectedTask)
            }, process.env.VUE_APP_QUIK_URL);
          },
          slug: 'visualizzaDettaglioTicket',
        },
        {
          label: 'Visualizza storia',
          command: () => {
            this.$store.dispatch('loadStoriaTask', { idTaskSprint: this.selectedTask.id, titoloLavoro: this.selectedTask.titoloLavoro, titoloAttivita: this.selectedTask.titoloAttivita });
          },
          slug: 'visualizzaStoria',
        },
        {
          label: 'Elimina',
          command: () => {
            this.eliminaTS(this.selectedTask);
          },
          slug: 'eliminaTS',
        },
      ],
      contextMenuCreaTask: [
        {
          label: 'Crea Task Sprint',
          command: () => {
            this.$store.dispatch('creaTaskSprint', { userId: this.userId, status: this.taskStatus });
          },
          slug: 'dettaglioTicket',
        },
      ]
    };
  },
  mounted() {
    this.load();
    //Aggiungi l'evidenziazione quando il mouse entra nel container
    // document.querySelectorAll('.task-container, .task-container.expanded').forEach(function(container) {
    //   container.addEventListener('dragenter', function() {
    //     container.classList.add('highlight');
    //   });
    //
    //   // Rimuovi l'evidenziazione quando il mouse esce
    //   container.addEventListener('dragleave', function() {
    //     container.classList.remove('highlight');
    //   });
    // });
    $('.task-container, .task-container.expanded').on('dragenter', function() {
      $(this).addClass('highlight'); // Aggiungi la classe 'highlight' al contenitore
    });

    // Rimuovi la classe 'highlight' quando il mouse lascia il contenitore
    $('.task-container, .task-container.expanded').on('dragleave', function() {
      $(this).removeClass('highlight'); // Rimuovi la classe 'highlight' dal contenitore
    });
  },

  created() {
    this.$store.subscribe(async (mutation, state) => {
      if (mutation.type === 'updateTaskPosition') {
        if (mutation.payload.status === this.taskStatus) {
          this.occupied.forEach((el) => {
            if (el.id === mutation.payload.id) {
              el.x = mutation.payload.left;
              el.y = mutation.payload.top;
              return;
            }
          });
          this.tasks = [...this.$store.getters.getByStatusAndUser(this.taskStatus, this.userId)];
        }
      }

      if (mutation.type === 'expandTaskSprint') {
        if (mutation.payload.userId === this.userId) {
          if (state.taskSprint.expandedBlock !== this.taskStatus) {
            this.expanded = false;
          }
        }
      }

      if (mutation.type === 'droppedTask') {
        if (mutation.payload.newStatus === this.taskStatus) {
          if (mutation.payload.el.idOwner == this.userId) {
            if (mutation.payload.oldStatus === 'BACKLOG' && mutation.payload.newStatus === 'TODO') {
              if (mutation.payload.el.idOwner == this.userId) {
                this.$store.dispatch('creaTaskSprint', { userId: this.userId, status: 'BACKLOG', modifica: true, daProgrammare:true, task: { ...mutation.payload.el } });
              }
            } else {
              if (mutation.payload.newStatus === 'REVIEW' || mutation.payload.newStatus === 'DONE'
                || (mutation.payload.oldStatus === 'REVIEW' && mutation.payload.newStatus === 'TODO')
                || (mutation.payload.oldStatus === 'DONE' && mutation.payload.newStatus === 'REVIEW')
                || (mutation.payload.oldStatus === 'DONE' && mutation.payload.newStatus === 'TODO')) {
                this.$store.dispatch('startInsertMessaggioTS', mutation.payload);
              } else {

                this.updateTaskStatus(mutation.payload.el);
              }
            }
          }
        }
        if (this.taskStatus === mutation.payload.oldStatus) {
          this.occupied = [...this.occupied.filter(e => e.id !== mutation.payload.el.id)];
          this.tasks = [...this.tasks.filter(e => e.id !== mutation.payload.el.id)];
        }
      }

      if (mutation.type === 'ownerUpdated') {
        if (this.userId == mutation.payload.oldOwner) {
          this.occupied = [...this.occupied.filter(occ => occ.id !== mutation.payload.id)]
        }
      }
    });


  },

  methods: {

    handleClick(event, item) {
      this.$refs.vueSimpleContextMenu1.showMenu(event, item);
    },
    onRightClick(event, task) {
      this.selectedTask = task;
      this.permettiHoverTask = false;
      this.$refs.menu.show(event);
    },
    onRightClickCreaTask(event) {
      if (this.isPM) {
        this.creatingTask = true;
        this.$refs.menuCreaTask.show(event);
      }
    },

    contextClosed() {
      this.selectedTask = null;
      this.permettiHoverTask = true;
    },
    optionClicked(event) {
      let operazione = event.option.slug;
      let item = { ...event.item };
      switch (operazione) {
        case 'descrizioneLavoro':
          if (!item.idTicketParent || item.idTicketParent <= 0)
            this.$store.dispatch('addMessage', {
              message: "Attenzione! questa attivita non fa parte di un lavoro ",
              messageType: 'warning'
            });
          else
            this.$store.dispatch('getDescrizioneLavoro', { idTicket: item.idTicketParent });
          break;
        case 'dettaglioTicket':
          this.$store.dispatch('getDettaglioTicket', { idTicket: item.idTicket });
          break;
      }
    },

    eliminaTS(task) {
      this.$confirm.require({
        message: 'Vuoi eliminare il TS selezionato?',
        header: 'Attenzione!',
        icon: 'pi pi-exclamation-triangle',
        blockScroll: true,
        rejectProps: {
          label: 'No',
          severity: 'secondary',
          outlined: true
        },
        acceptProps: {
          label: 'Si'
        },
        accept: () => {
          this.$store.dispatch("eliminaTS", { idTask: task.id });
        },
        reject: () => {
        }
      });
    },

    expand() {
      if (!this.expanded) {
        const taskType = this.taskStatus;
        this.$store.dispatch('expandTaskSprint', { taskType, userId: this.userId });
        this.expanded = true;
      }
    },

    taskDrop(e) {

      document.querySelectorAll('.task-container').forEach(function(container) {
        container.classList.remove('highlight');
      });


      let elementDropped = JSON.parse(e.dataTransfer.getData("element"));
      if(elementDropped.creaDaAttivita){
        this.$store.dispatch('creaTaskSprint', {...elementDropped, status:this.taskStatus});
        return;
      }
      if (!this.isPM && this.taskStatus === 'DONE' && elementDropped.richiedeApprovazione === true) {
        if(elementDropped.status==='REVIEW'){
          this.$confirm.require({
            message: 'Non è possibile chiudere il Task direttamente,\n\r Attendere la conferma del PM',
            header: 'Attenzione!',
            icon: 'pi pi-exclamation-triangle',
            blockScroll: true,
            rejectClass: 'hide',
            acceptProps: {
              label: 'Ok'
            },
          });
          return;
        }
        this.$store.dispatch('addMessage',{
          message: "Non è possibile chiudere il Task direttamente. Spostato nella colonna Review",
          messageType: 'info'
        })
        // commit('addMessage', {
        //     message: "VUEX loadTasks OK!",
        //     messageType: 'info'
        // });

        // this.$confirm.require({
        //   message: 'Non è possibile chiudere il Task direttamente,\n\r lo sposto nella colonna Review',
        //   header: 'Attenzione!',
        //   icon: 'pi pi-exclamation-triangle',
        //   blockScroll: true,
        //   rejectClass: 'hide',
        //   acceptProps: {
        //     label: 'Ok'
        //   },
        // });



        let droppedElement = {
          newStatus: 'REVIEW',
          oldStatus: elementDropped.status,
          el: { ...elementDropped }
        }
        this.$store.dispatch('droppedTask', droppedElement);
        return;
      }
      e.stopImmediatePropagation();

      let droppedElement = {
        newStatus: this.taskStatus,
        oldStatus: elementDropped.status,
        el: { ...elementDropped }
      }
      if (elementDropped.status !== this.taskStatus) {
        this.$store.dispatch('droppedTask', droppedElement);
      } else {
        // const rect = event.currentTarget.getBoundingClientRect();
        // const mouseX = event.clientX - rect.left; // Posizione X del mouse relativa al container
        // const mouseY = event.clientY - rect.top; // Posizione Y del mouse relativa al container
        //
        // const elementWidth = 500;
        // const elementHeight = 120;
        //
        // const elementX = mouseX - elementWidth / 2;
        // const elementY = mouseY - elementHeight / 2;
        // this.$store.dispatch('updateTaskPosition', {
        //   id: droppedElement.el.id,
        //   left: elementX,
        //   top: elementY,
        //   status: droppedElement.el.status
        // });
      }
    },

    allowDrop(ev) {
      //return false;
      ev.preventDefault();
    },

    async load() {
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'tasksLoaded') {
          //this.occupied=[];
          let tasks = [...this.$store.getters.getByStatusAndUser(this.taskStatus, this.userId)];
          this.arrangeElements(tasks);
          this.$store.dispatch('storeUpdateTasks', {
            tasks: [...tasks]
          })
          if(this.isPM)
          this.tasks = [...tasks];
          else{
            this.tasks=[...tasks.filter(t=>t.tag!=='PROGRAMMATO')]
          }

        }
        if (mutation.type === 'statusUpdated') {
          let tasks = [...this.$store.getters.getByStatusAndUser(this.taskStatus, this.userId)];
          if (mutation.payload.status === this.taskStatus) {
            this.arrangeElements(tasks);
            this.$store.dispatch('storeUpdateTasks', {
              tasks: [...tasks]
            })
          }
          if(this.isPM)
            this.tasks = [...tasks];
          else{
            this.tasks=[...tasks.filter(t=>t.tag!=='PROGRAMMATO')]
          }
        }
        if (mutation.type === 'dodEdited' || mutation.type === 'tasksUpdated') {
          let tasks = [...this.$store.getters.getByStatusAndUser(this.taskStatus, this.userId)];
          if(this.isPM)
            this.tasks = [...tasks];
          else{
            this.tasks=[...tasks.filter(t=>t.tag!=='PROGRAMMATO')]
          }
        }
      })
      if (!this.isPM) {
        this.contextMenuActions = [...this.contextMenuActions.filter(cma => cma.slug !== 'cambiaEsecutore' && cma.slug !== 'duplica' && cma.slug !== 'eliminaTS' && cma.slug!=='modificaTS' && cma.slug!=='riprogramma')]
      }
      if (this.isPM) {
        this.contextMenuActions = [...this.contextMenuActions.filter(cma => cma.slug !== 'startTimbratura' && cma.slug!=='visualizzaDettaglioTicket' )]
      }
    },

    updateTaskStatus(task) {
      if (task.idOwner == this.userId)
        this.$store.dispatch("updateStatus", {
          ...task, taskStatus: this.taskStatus,
          oldStatus: task.status,
        });
    },

    arrangeElements(elements, space = 20) {

      // let containerWidth = this.getContainerMaxWidth();
      // let currentX = space;
      // let currentY = space;
      // let rowHeight = 0;
      //
      // const isOccupied = (x, y, width, height) => {
      //   return this.occupied.some(pos =>
      //     !(x + width <= pos.x || // Elemento alla sinistra
      //       x >= pos.x + pos.width || // Elemento alla destra
      //       y + height <= pos.y || // Elemento sopra
      //       y >= pos.y + pos.height) // Elemento sotto
      //   );
      // };
      // elements.forEach((el) => {
      //
      //   if (!el.style.left) {
      //     const elementWidth = 500;
      //     const elementHeight = 120;
      //
      //     if (currentX + elementWidth > containerWidth) {
      //       currentX = space;
      //       currentY += elementHeight + space;
      //     }
      //     // Controlla se l'elemento si adatta alla riga corrente
      //     while (isOccupied(currentX, currentY, elementWidth, elementHeight)) {
      //       currentX += elementWidth + space;
      //       // Se superiamo la larghezza del container, passiamo alla riga successiva
      //       if (currentX + elementWidth > containerWidth) {
      //         currentX = space;
      //         currentY += elementHeight + space;
      //       }
      //     }
      //     el.style = {}
      //     // Posiziona l'elemento
      //     el.style.left = `${currentX}px`;
      //     el.style.top = `${currentY}px`;
      //     el.style.position = "absolute";
      //
      //
      //
      //     this.occupied.push({
      //       x: currentX,
      //       y: currentY,
      //       width: elementWidth,
      //       height: elementHeight,
      //       id: el.id
      //     });
      //
      //     // Aggiorna le coordinate per il prossimo elemento
      //     currentX += elementWidth + space;
      //     rowHeight = Math.max(rowHeight, elementHeight);
      //   }
      // });
    },

    getContainerMaxWidth() {
      const rowTasks = document.querySelector('.row-tasks.row-hidden .task-container.expanded')
      const status = document.querySelector('.status');

      let rowWidth = 1300;
      let paddingLeft = 20;
      let paddingRight = 20;
      if (rowTasks?.clientWidth !== 0) {
        rowWidth = rowTasks?.clientWidth;
        paddingLeft = 30
        paddingRight = 30
      }

      const availableWidth = rowWidth - paddingLeft - paddingRight;

      const statusWidth = status ? status.clientWidth : 0;
      return (availableWidth) - 50 - statusWidth;
    },
    reloadData(){
      let lastFetch=this.$store.getters.getLastFetch();
      this.$store.dispatch('refreshTasks',{
        lastFetch:lastFetch,
        isPM:this.isPM
      });
    }
  },
};
</script>
